/**
 * The one place that decides what colour a title has: the dashboard's, the foreground ink.
 * Colour stays for action, state and selection; hierarchy comes from weight and size.
 */
export const TITLE_COLOR_CLASS = 'text-foreground';
